define("shared/components/shared/ui/social-profile-switcher/linkinbio/page-avatar", ["exports", "@ember/component", "@glimmer/component", "later/helpers/profile-color-outline-class", "@ember/template-factory"], function (_exports, _component, _component2, _profileColorOutlineClass, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"later/helpers/profile-color-outline-class",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--user {{this.outlineClass}}" data-profile-type="lib" data-uid={{@socialProfile.uid}}>
    <span class="o--user__avatarProfile">
      <img
        alt={{this.urlName}}
        class="o--user__avatar {{@avatarClass}}"
        data-test-avatar
        draggable="false"
        ondragstart="return false;"
        src={{@linkinbioPage.avatarUrl}}
      />
    </span>
  
    <span class="o--user__title" data-test-id="nickname">
      <span class="u--ellipsis {{@handleQaClass}}">
        {{this.urlName}}
      </span>
    </span>
    <span class="o--user__desc" data-test-id="description">
      <span class="u--ellipsis">
        {{this.linkinbioShortUrl}}
      </span>
    </span>
  </div>
  */
  {
    "id": "/1JSyfC5",
    "block": "[[[10,0],[15,0,[29,[\"o--user \",[30,0,[\"outlineClass\"]]]]],[14,\"data-profile-type\",\"lib\"],[15,\"data-uid\",[30,1,[\"uid\"]]],[12],[1,\"\\n  \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n    \"],[10,\"img\"],[15,\"alt\",[30,0,[\"urlName\"]]],[15,0,[29,[\"o--user__avatar \",[30,2]]]],[14,\"data-test-avatar\",\"\"],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,\"src\",[30,3,[\"avatarUrl\"]]],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,1],[14,0,\"o--user__title\"],[14,\"data-test-id\",\"nickname\"],[12],[1,\"\\n    \"],[10,1],[15,0,[29,[\"u--ellipsis \",[30,4]]]],[12],[1,\"\\n      \"],[1,[30,0,[\"urlName\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,1],[14,0,\"o--user__desc\"],[14,\"data-test-id\",\"description\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,\"\\n      \"],[1,[30,0,[\"linkinbioShortUrl\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@socialProfile\",\"@avatarClass\",\"@linkinbioPage\",\"@handleQaClass\"],false,[]]",
    "moduleName": "shared/components/shared/ui/social-profile-switcher/linkinbio/page-avatar.hbs",
    "isStrictMode": false
  });
  class PageAvatarComponent extends _component2.default {
    get socialProfile() {
      return this.args.socialProfile;
    }
    get linkinbioPage() {
      return this.args.linkinbioPage;
    }
    get urlName() {
      return this.linkinbioPage.get('urlName');
    }
    get outlineClass() {
      if (!this.socialProfile?.get('profileColorClass')) {
        return '';
      }
      return (0, _profileColorOutlineClass.profileColorOutlineClass)([this.socialProfile.get('profileColorClass')]);
    }
    get linkinbioShortUrl() {
      return this.linkinbioPage.get('urlTruncated');
    }
  }
  _exports.default = PageAvatarComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PageAvatarComponent);
});